const $ = jQuery.noConflict()

var self = module.exports = {
  init: function(trigger) {
    self.events.load(trigger)
  },

  events: {
    load: function(trigger) {
      $(window).scroll(function() {
        $(trigger).each(function() {
          if($(this).attr('data-src') && !$(this).closest('.modal').length && $(this).attr('src') == '') {
            if( $(window).scrollTop() > $(this).offset().top - 300 ) {
              $(this).attr('src',$(this).attr('data-src'));
            }
          }
        })
      })
    }
  }
}
